import { QueryClient } from '@tanstack/query-core'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 20,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
